module.exports = __webpack_public_path__ + "static/media/transactions.a63f323a.jpg";